// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__0zCFp","avatar":"Panel_avatar__N0mzK","brand":"Panel_brand__5NUbW","share":"Panel_share__-dxyA","counter":"Panel_counter__XewFg"};